<template>
  <span v-html="icon"></span>
</template>
<script>
  export default {
    props: ['id'],
    computed: {
      icon() {
        return window.wf.svgs[this.id]
      }
    }
  }
</script>
